import { DEVICE_TYPE, LEAVE_ROLE } from '@/utils/constUtils'
/********************************************************************
 * 魔方微应用
 ********************************************************************/

export const educationalMenusZj = [
  {
    id: 30,
    name: '班级放学',
    icon: '&#xe6e6;',
    module: '30',
    path: '/afterschool/index',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster]
  },
  {
    id: 31,
    name: '学生留堂',
    title: 'detention',
    path: '/afterschool/detention/index',
    icon: '&#xe6e7;',
    module: '31',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.teacher]
  },
  {
    id: 6,
    name: '滞留生托管',
    path: '/flexleave/index',
    icon: '&#xe672;',
    module: '8',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.teacher]
  },
  {
    id: 1,
    name: '学生考勤',
    path: '/attendance/index',
    icon: '&#xe675;',
    module: '1',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 2,
    name: '学生请假',
    path: '/leave/index',
    icon: '&#xe677;',
    module: '2',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 4,
    name: '学生宿舍',
    path: '/dorm/index',
    icon: '&#xe679;',
    module: '4',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.dormAdmin,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 20,
    name: '德育考评',
    title: 'moral',
    termNotNull: true,
    multiple: true,
    path: {
      1: '/classcard/moralstudent', // 家长
      [LEAVE_ROLE.classTeacher]: '/classcard/moral'
    },
    icon: '&#xe709;',
    module: '20',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.meTeacher,
      LEAVE_ROLE.customRole
    ],
    platformSources: [9]
  },
  {
    id: 21,
    name: '班级评比',
    title: 'classrank',
    termNotNull: true,
    path: '/classcard/classrankall',
    icon: '&#xe708;',
    module: '21',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.ceTeacher,
      LEAVE_ROLE.meTeacher,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.customRole,
      LEAVE_ROLE.classrankApprover
    ],
    platformSources: [9]
  },
  {
    id: 41,
    name: '学生荣誉',
    path: '/classcard/honour/list',
    icon: '&#xe69c;',
    module: '41',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.customRole],
    platformSources: [9]
  },
  {
    id: 29,
    name: '亲情通话',
    path: '/classcard/familycall/list',
    icon: '&#xe69a;',
    module: '29',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.customRole],
    platformSources: [9]
  },
  {
    id: 24,
    name: '通知公告',
    path: '/classcard/welcome',
    query: { publishType: 2 },
    icon: '&#xe693;',
    module: '24',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.customRole],
    platformSources: [9]
  },
  {
    id: 23,
    name: '欢迎词',
    path: '/classcard/welcome',
    icon: '&#xe691;',
    module: '23',
    query: { publishType: 1 },
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.customRole],
    platformSources: [9]
  },
  {
    id: 7,
    name: '数据大屏',
    path: '/screen/index',
    icon: '&#xe678;',
    module: '7',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.customRole]
  },
  {
    id: 43,
    title: 'classEvaluation',
    name: '课堂评价',
    path: '/classevaluation/index',
    icon: '&#xe6a7;',
    module: '43',
    termNotNull: true,
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.customRole
    ],
    platformSources: [9]
  },
  {
    id: 42,
    name: '光盘行动',
    icon: '&#xe6a8;',
    module: '42',
    multiple: true,
    termNotNull: true,
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.student,
      LEAVE_ROLE.customRole
    ],
    path: {
      1: '/classcard/clearplate/personal', // 家长
      7: '/classcard/clearplate/personal', // 学生
      [LEAVE_ROLE.classTeacher]: '/classcard/clearplate'
    },
    platformSources: [9]
  },
  {
    id: 70,
    name: '每日食谱',
    icon: '&#xe6d2;',
    module: '70',
    termNotNull: true,
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.customRole
    ],
    path: '/recipes/adminDaily',
    platformSources: [9]
  },
  {
    id: 26,
    name: '班级课表',
    multiple: true,
    termNotNull: true,
    icon: '&#xe734;',
    module: '26',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.guardian
    ],
    path: {
      1: '/schedule/student', // 家长
      [LEAVE_ROLE.classTeacher]: '/schedule/timetable'
    },
    platformSources: [9]
  },
  {
    id: 52,
    name: '调代课',
    title: 'substitute',
    path: '/substitute/index',
    module: '52',
    termNotNull: true,
    icon: '&#xe735;',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.teacher,
      LEAVE_ROLE.customRole
    ],
    platformSources: [9]
  },
  {
    id: 22,
    name: '给孩子留言',
    path: '/classcard/classrank/message',
    icon: '&#xe6df;',
    module: '22',
    access: [LEAVE_ROLE.guardian],
    platformSources: [8, 9]
  },
  {
    id: 161,
    name: '进出校管理',
    path: '/opendoor/index',
    icon: '&#xe796;',
    module: '161',
    access: [LEAVE_ROLE.admin],
    platformSources: [2]
  },
  {
    id: 162,
    name: '在校统计',
    path: '/atschool/summary',
    icon: '&#xe79d;',
    module: '162',
    access: [LEAVE_ROLE.admin],
    platformSources: [2]
  },
  {
    id: 95,
    name: '智慧停车',
    path: '/vehiclemanage/index',
    icon: '&#xe6c4;',
    module: '95',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.customRole]
  },
  {
    id: 27,
    module: '27',
    routerType: 2,
    belong: 'deviceMange',
    name: '班牌管理',
    path: `/classcard/mamage`,
    query: { deviceType: [DEVICE_TYPE.T1, DEVICE_TYPE.T21] },
    icon: '&#xe71b;',
    access: [LEAVE_ROLE.admin],
    platformSources: [9]
  },
  {
    id: 28,
    name: '学期时间',
    title: 'schoolCalendar',
    path: '/schoolCalendar',
    icon: '&#xe775;',
    module: '28',
    access: [LEAVE_ROLE.admin]
  },
  {
    id: 171,
    name: '学生用餐',
    multiple: true,
    path: {
      1: '/meal/calendar', // 家长
      3: '/meal/index',
      [LEAVE_ROLE.customRole]: '/meal/index',
      [LEAVE_ROLE.classTeacher]: '/meal/index'
    },
    icon: '&#xe7a6;',
    module: '171',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.guardian],
    platformSources: [2, 12]
  }
]

export const mainMenusZj = []
export const otherMenusZj = []
export const securityMenusZj = []
export const devicesMenusZj = []
export const leaveSchoolMenusZj = []
export const basicMenusZj = []
export const serveMenusZj = []
export const evaluationMenusZj = []
